import { ParameterChange } from '@dossier/models/parameter-changes';

export enum ChangesSectionType {
  Common = 'Common',
  DangerousGoodsIndication = 'DangerousGoodsIndication',
  ExceptionalGaugingIdent = 'ExceptionalGaugingIdent',
  ImParameter = 'ImParameter',
  LocoIdents = 'LocoIdents',
}

export interface ParameterChangesSection {
  changes: ParameterChange[];
  changesSectionType: ChangesSectionType;
}
